// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormThreeWaySwitchReadOnly_wrapper"};